import script from "./LocationsMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./LocationsMenu.vue?vue&type=script&lang=ts&setup=true"

import "./LocationsMenu.vue?vue&type=style&index=0&id=34ec2414&lang=css"

const __exports__ = script;

export default __exports__